import { ActivityLogObject } from '@models';

export interface ProjectActivityLogResult {
  projectActivityLogs: ActivityLogObject;
}
